import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import './style.css';

// Shown above Inspect when access is the user's alone (useInspect role, stack has Inspect off).
function Notice(props) {
  var t = props.t;
  return (
    <div className="inspect-access-notice" role="note">
      <span className="material-symbols-outlined inspect-access-notice-icon">info</span>
      <span className="inspect-access-notice-text">
        {t('inspectLanding:accessNotice', { stack: props.stackName })}
      </span>
    </div>
  );
}

function mapStateToProps(state) {
  var current = state.accounts && state.accounts.currentAccount;
  return { stackName: (current && current.name) || '' };
}

export default withTranslation()(connect(mapStateToProps)(Notice));
